import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

const readable = (text, names) => text.replace(/\[\[(bundle:)?([a-z0-9-]+)\]\]/g, (_, b, slug) => (b ? `→ Bundle: ${slug.replace(/-/g, " ")}` : `→ ${names[slug] || slug}`));

export const AdminChats = () => {
  const [chats, setChats] = useState(null);
  const [names, setNames] = useState({});
  useEffect(() => {
    api.get("/admin/chats").then(({ data }) => setChats(data)).catch(() => setChats([]));
    api.get("/admin/products").then(({ data }) => setNames(Object.fromEntries(data.map((p) => [p.slug, p.name])))).catch(() => {});
  }, []);
  if (!chats) return null;
  if (!chats.length) return <p data-testid={ADMIN.chatsEmpty} className="mt-6 text-sm text-stone-500">No shopper chats yet.</p>;
  return (
    <ul data-testid={ADMIN.chatsList} className="mt-6 space-y-3">
      {chats.map((c) => (
        <li key={c.session_id} data-testid={ADMIN.chatSession(c.session_id)}>
          <details className="bg-white border border-[#F0EBE1] rounded-2xl p-4">
            <summary className="cursor-pointer text-sm flex justify-between gap-4">
              <span className="font-medium truncate">{c.messages.find((m) => m.role === "user")?.text || "Chat"}</span>
              <span className="text-stone-500 whitespace-nowrap">{c.count} messages · {new Date(c.last).toLocaleString()}</span>
            </summary>
            <div className="mt-3 space-y-2">
              {c.messages.map((m, i) => (
                <p key={i} className={`text-sm whitespace-pre-line rounded-xl px-3 py-2 ${m.role === "user" ? "bg-[#F0EBE1]" : "bg-[#FDFBF7] border border-[#F0EBE1]"}`}>
                  <span className="font-semibold">{m.role === "user" ? "Shopper" : "Kiddee"}:</span> {readable(m.text, names)}
                </p>
              ))}
            </div>
          </details>
        </li>
      ))}
    </ul>
  );
};
